(function ($) {
    $(document).ready(function () {
        anchors();
    });

    jQuery(window).smartresize(function () {
        anchorsSlider();
    });

    $(window).on('scroll', function () {
        addFixedClass();
    })

    function anchors() {
        var wrap = $('.anchors .wrap'),
            wrapHeight = $('body').hasClass('blog') ? $('#header_wrapper').height() + $('.anchors_wrap').height() + 30 : $('.anchors_wrap').height() + 30,
            breadcrumbHeight = $('#breadcrumb').outerHeight() + 80;

        if (wrap.length > 0) {
            wrap = wrap.eq(0);
            var items = wrap.find('a');
            items.each(function () {
                var item = $(this);
                var goTo = '#' + item.attr('data-scroll');
                if (false && $(goTo).length === 0) {
                    item.remove();
                } else {
                    item.click(function () {
                        var goTo = '#' + item.attr('data-scroll');
                        if (goTo.startsWith('#main-content')) {
                            var top = $(goTo).offset().top - wrapHeight - breadcrumbHeight;
                        } else {
                            var top = $(goTo).offset().top - wrapHeight;
                        }
                        $('html,body').stop().animate({scrollTop: top}, 500);
                        if ($(goTo).find('.slick-initialized').length > 0) {
                            $(goTo).find('.slick-slide:not(.slick-cloned) a').eq(0).focus();
                        } else {
                            $(goTo).find('a,input[type!="hidden"]').eq(0).focus();
                        }
                    });
                }
            });

            var sections = $('.section');

            var options = {
                rootMargin: '-30% 0px -30% 0px',
            }

            var observer = new IntersectionObserver(function (entry, observer) {
                if (entry[0].intersectionRatio > 0) {
                    items.each(function () {
                        var item = $(this);
                        if (item.attr('data-scroll') == entry[0].target.id) {
                            wrap.find('a').removeClass('active');
                            item.addClass('active');
                        }
                    })
                }
            }, options);

            $.each(sections, function () {
                observer.observe($(this).get(0));
            })

            anchorsSlider();
        }
        anchorsAddClass();
    }

    function anchorsAddClass() {
        var anchors = $('.anchors'),
            header = $('#header_wrapper');

        if (anchors.length > 0) {
            var headerHeight = header.height();
            var closestSection = null;
            jQuery('.section').each(function () {
                var s = jQuery(this),
                    paddingTxt = $('.section').eq(1).css('padding-bottom'),
                    padding = paddingTxt.replace('px', ''),
                    topPosition = s.offset().top - padding,
                    distance = topPosition - headerHeight - jQuery(document).scrollTop() - 1;
                if (distance <= 0) {
                    closestSection = s;
                }
            });
            if (closestSection !== null) {
                jQuery('.anchors .active').removeClass('active');
                jQuery('.anchors a[data-scroll="' + closestSection.attr('id') + '"]').addClass('active');
            }
        }
    }

    function addFixedClass() {
        var anchors = $('.anchors'),
            header = $('#header_wrapper'),
            slideshow = $('.slideshow_container'),
            hasSlideshow = slideshow.length > 0,
            slideshowHeight = hasSlideshow ? slideshow.height() : 0,
            headerHeight = header.height(),
            bookingformHeight = $('.bookingform_wrapper').height(),
            scroll = $(window).scrollTop(),
            fixed = 'fixed',
            breakpoint = !is_mobile ? slideshowHeight - headerHeight : slideshowHeight - headerHeight + bookingformHeight;

        if (is_mobile) {
            if (scroll > breakpoint) {
                anchors.addClass(fixed);
                header.addClass(fixed);
            } else {
                anchors.removeClass(fixed);
                header.removeClass(fixed);

            }
        } else {
            if (header.hasClass(fixed)) {
                anchors.addClass(fixed);
            } else {
                anchors.removeClass(fixed)
            }
        }
    }

    function anchorsSlider() {
        var main_wrap = $('.anchors .anchor_navigation_container');
        if (main_wrap.length > 0) {
            var wrap = main_wrap.find('.wrap');
            var wrap_width = wrap.width();
            var labels = wrap.find('.label');
            var labels_width = 0;
            if (!is_mobile) {
                labels.each(function () {
                    labels_width = labels_width + $(this).outerWidth(true);
                });
                if (labels_width > wrap_width) {
                    main_wrap.addClass('slider_is_visible');
                    if (!wrap.hasClass('slick-initialized')) {
                        wrap.removeAttr('role').removeAttr('aria-label');

                        var arrows = main_wrap.find('.arrow');
                        wrap.on('init', function () {
                            arrows.each(function () {
                                if ($(this).hasClass('slick-disabled')) {
                                    $(this).attr('tabindex', -1);
                                }
                            });

                        });
                        //After change removed the focus to arrows and focus on next slide
                        wrap.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                            arrows.blur();
                            var NextSlide = $(slick.$slides.get(nextSlide));
                            NextSlide.focus();
                        });

                        wrap.slick({
                            infinite: false,
                            variableWidth: true,
                            slidesToScroll: 1,
                            slidesToShow: 1,
                            rows: 0,
                            arrows: true,
                            nextArrow: main_wrap.find('.next'),
                            prevArrow: main_wrap.find('.prev'),
                            rtl: $('html').attr('dir') == 'rtl',
                        });

                        arrows.each(function () {
                            $(this).on('click', function () {
                                if (!$(this).hasClass('slick-disabled')) {
                                    $(this).siblings().removeAttr('tabindex');
                                } else {
                                    $(this).attr('tabindex', -1);
                                }
                            });
                        });


                    }
                } else {
                    main_wrap.removeClass('slider_is_visible');
                    if (wrap.hasClass('slick-initialized')) {

                        wrap.slick('unslick');
                    }
                }
            }
        }
    }
})(jQuery);